<div [formGroup]="searchConditionForm">
    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
        <mat-expansion-panel-header class="mat-panel-header-text">
            <mat-panel-title>検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-[600px] tw-max-w-[600px] tw-min-w-[600px]"
                floatLabel="always">
                <mat-label>督促管理区分</mat-label>
                <input matInput style="display: none!important" formControlName="pressmanagementdivisionCodeList">
                <mat-selection-list formControlName="pressmanagementdivisionCodeList"
                    class="tw-flex tw-flex-row tw-flex-wrap" style="display: flex;"
                    (selectionChange)="onChangeTokusokuKubun()">
                    <mat-list-option *ngFor="let status of tokusokuKubunList;" [value]="status.value"
                        (selectedChange)="getControl('pressmanagementdivisionCodeList')?.markAsTouched()"
                        class="mat-list-option" color="primary" checkboxPosition="before">
                        {{status.viewValue}}
                    </mat-list-option>
                </mat-selection-list>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>会社</mat-label>
                <mat-select formControlName="companycode" class="disabled-select-color"
                    (valueChange)="onChangeCompany($event)">
                    <mat-option *ngIf="companycodeList.length != 1"></mat-option>
                    <mat-option *ngFor="let type of companycodeList" [value]="type.value">{{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline"
                class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>地区（営業）</mat-label>
                <mat-select formControlName="areaTradeCode" class="disabled-select-color">
                    <mat-option *ngIf="companycodeList.length != 1"></mat-option>
                    <mat-option *ngFor="let type of areaTradeCodeList" [value]="type.value">{{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>地区（供給地点）</mat-label>
                <mat-select formControlName="areaSuppntCode" autocomplete="off">
                    <mat-option *ngFor="let type of areaSuppntCodeList"
                        [value]="type.value">{{type.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-checkbox id="alldateHyojiFlg"
                class="check-box tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] tw-ml-[50px]"
                color="primary" formControlName="alldateHyojiFlg">明日以降の作業予定も表示
            </mat-checkbox>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="submit" mat-raised-button color="primary" class="btn"
                    [disabled]="searchConditionForm.invalid">検索</button>
            </mat-action-row>
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="button" mat-raised-button color="primary" class="btn"
                    (click)="onClickClear()">クリア</button>
            </mat-action-row>
        </div>
    </mat-expansion-panel>
</div>